import React, { useEffect } from "react";
import { Card } from "react-bootstrap";
import { useLogout, DefaultRoutes } from "src/common";
import { Icon } from "src/components";
import AccountDeletedImage from "src/assets/images/account-deleted.svg";

function AccountDeletedComponent() {
  const { handleStateLogout } = useLogout();

  useEffect(() => {
    handleStateLogout();
  }, []);

  return (
    <div className="mx-auto max-600 mt-4">
      <h1 className="main-header">This user was removed.</h1>
      <Card className="pv-card mb-2">
        <Card.Img variant="top" src={AccountDeletedImage} />
        <Card.Body>
          <p className="semi-bold fs-3 mb-4">This user has been removed by a PreVeil administrator.</p>
          <p>Please contact your organization's administrator for more information.</p>
        </Card.Body>
      </Card>
      <p><Icon className="pv-icon-question" /><span>Learn more about locked devices <a target="_blank" rel="noreferrer" href={`${DefaultRoutes.remote_webapp_url}/support`}>preveil.com/support</a></span></p>
    </div>
  );
}

export default React.memo(AccountDeletedComponent);
